export default "__VITE_PUBLIC_ASSET__4911832e__"